import webapiService from "@/services/webapi.service";

const state = {
    province: null,
    nazioni: null
}

const getters = {
    getProvince: (state) => {
        return state.province ?? JSON.parse(sessionStorage.getItem("province"));
    },
    getNazioni: (state) => {
        return state.nazioni;
    }
}

const mutations = {
    setProvince:  (state, province) => {
        state.province = province;
        sessionStorage.setItem("province", JSON.stringify(state.province));
    },
    setNazioni:  (state, nazioni) => {
        state.nazioni = nazioni;
    }
}

const actions = {
    setProvinceApi: ({commit}) => {
        return webapiService.getWApiKey("Risorse/Province").then(
            (data) => {
                if(data){
                    commit("setProvince", data.Data);
                }
            }
        );
    },
    GetNazioniApi: ({commit},data) => {
        return webapiService.get("Anagrafica/Nazioni",data.Token, null, null).then(
            (data) => {
                if(data){
                    commit("setNazioni", data.data);
                }
            }
        );
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}